import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, User } from 'lucide-react';
import { SectionCard } from '../common/SectionCard';
import { formatDate } from '../../utils/format';
import type { ApplicationRecord } from '../../types/domain';
export function ActivityFeed({
  records
}: {
  records: ApplicationRecord[];
}) {
  const events = records.flatMap(record => record.timeline.map(event => ({
    record,
    event
  }))).sort((a, b) => b.event.on.localeCompare(a.event.on)).slice(0, 8);
  return <SectionCard title="Recent activity" description="Latest decisions, submissions and AI runs across the portfolio" bodyClassName="p-0" data-id="element-586" data-mp="3rsvelt9f2tpd">
      <ol className="divide-y divide-border" data-id="element-587" data-mp="3it8a2yle57s3">
        {events.map(({
        record,
        event
      }) => {
        const isAi = event.actor.startsWith('AI');
        const Icon = isAi ? Sparkles : User;
        return <li key={`${record.id}-${event.id}`} data-id="element-588" data-mp="38uiu5bd21xeh">
              <Link to={`/applications/${record.id}`} className="flex items-start gap-3 px-4 py-2.5 hover:bg-muted" data-id="element-589" data-mp="38vu6w0ohafhq">
                <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-sm ${isAi ? 'bg-uae-gold/15 text-uae-bronze' : 'bg-uae-leaf/10 text-uae-leaf'}`} data-id="element-590" data-mp="19nhg9nb7eatm">
                  <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-591" data-mp="10rrrd4ajqybh" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-592" data-mp="1ohvqozgpcbwo">
                  <p className="text-[12px] leading-snug" data-id="element-593" data-mp="1ska95iggl9nf">
                    <span className="font-medium" data-id="element-594" data-mp="1elj04aggee65">{event.label}</span>
                    <span className="text-muted-foreground" data-id="element-595" data-mp="1elamuhgf56uf"> · {record.eventName}</span>
                  </p>
                  <p className="text-[11px] text-muted-foreground" data-id="element-596" data-mp="1jmq5k2v4j19n">
                    {event.actor} · {formatDate(event.on)}
                  </p>
                </div>
              </Link>
            </li>;
      })}
      </ol>
    </SectionCard>;
}